module.exports = __webpack_public_path__ + "img/stopspillet.0f7f94cf.png";